module.exports = __webpack_public_path__ + "img/PlayPortafolioReel.3fa93d94.svg";